import type { OperatorStatus } from '../store/auth';

// ANX-071 — цветной индикатор статуса оператора.
export type DisplayStatus = OperatorStatus | 'offline';

const COLOR: Record<DisplayStatus, string> = {
  online: 'bg-emerald-500',
  away: 'bg-amber-400',
  busy: 'bg-rose-500',
  offline: 'bg-slate-300',
};

export function StatusDot({ status, className = '' }: { status: DisplayStatus; className?: string }) {
  return (
    <span
      className={`inline-block h-2 w-2 shrink-0 rounded-full ${COLOR[status]} ${className}`}
      aria-hidden="true"
    />
  );
}
